import axios, { AxiosError } from 'axios';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import {MenuMaster} from "../../../models/config/MenuMaster";
import {ResponseError} from "../../../models/common/Response";

export function useUpdateMenuMaster(
    options?: UseMutationOptions<
        MenuMaster,
        AxiosError<ResponseError>,
        MenuMaster
    >
) {
    return useMutation({
        mutationFn: request => {
            const accessToken = localStorage.getItem('LG_APPLICATION');
            return axios.put('/v1/configuration/lis/menu', request, {
                headers: {
                    Authorization: `Bearer ${accessToken}`
                }
            });
        },
        ...options
    });
}
